import { SITE_NAME, SITE_URL } from 'config'

export { SITE_NAME, SITE_URL }

export const absoluteUrl = (path = '/') => (path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`)

// Brand blue (tailwind.config.js `maplexxon-blue`), used for <meta name="theme-color">.
export const THEME_COLOR = '#0053CF'

// Default share image: public/og-banner.jpg (1200x630).
export const DEFAULT_IMAGE = {
    path: '/og-banner.jpg',
    width: 1200,
    height: 630,
    alt: 'Maplexxon: ready-made solutions to support your business',
}

// Square brand logo in public/ (stable URL for Organization.logo).
export const LOGO_PATH = '/logo512.png'

// Company details as published on the site (src/pages/ContactUs.js and
// src/components/Footer/Footer.js). Keep in sync when those change.
export const organization = {
    name: SITE_NAME,
    legalName: 'PT Cendekia Edukasi Citra Tritunggal',
    email: 'sales@maplexxon.com',
    telephone: '+62-811-1094-8899',
    officeTelephone: '+62-21-8064-7744',
    address: {
        streetAddress: 'AKR Tower 16th Floor Unit 16A, Jl Panjang No. 5, Kebon Jeruk',
        addressLocality: 'West Jakarta',
        postalCode: '11530',
        addressCountry: 'ID',
    },
    openingHours: { days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '10:00', closes: '18:00' },
    sameAs: [
        'https://www.instagram.com/maplexxon/',
        'https://www.linkedin.com/company/maplexxon',
    ],
    parentOrganization: { name: 'Cloudxier', url: 'https://cloudxier.com/' },
}
